module.exports = __webpack_public_path__ + "static/img/16.9e71329.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/16.png
// module id = LIl5
// module chunks = 0